import { ISettingsStore } from './settings-store';
import { of, Observable } from 'rxjs';

export class SessionStorageSettingsStore implements ISettingsStore {
  private readonly _settingPrefix = '________INFORSER_WEBID_GLOBAL_SETTING_';
  getSetting$(key: string): Observable<string | null> {
    return of(sessionStorage.getItem(this._settingPrefix + key));
  }
  setSetting$(settingKey: string, value: string): Observable<boolean> {
    sessionStorage.setItem(this._settingPrefix + settingKey, value);
    return of(true);
  }
}
